import React from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'
import { getTranslation, getAlerts } from '@/store/getters'
import { closeAlert } from '@/store/actions'
import styles from './styles.scss'

/** Components */
import Modal from '@/components/Modal'

const AlertModal = props => {
  const { translation, closeAlert, alerts } = props
  const { title, message, isOpened, callback, type } = alerts

  return (
    <Modal show={isOpened} handleClose={closeAlert} >
      <div className={`ba-card ${styles['ba-modal-card']}`}>
        <div class={`ba-toast ba-${type} ba-w-100 ${styles['ba-modal-card__title']}`}>
          <div class="ba-toast-alert">
            <div class="ba-left">
              <span class="ba-icon"></span>
              <span class="ba-text ba-montserrat-700">{translation(title)}</span>
            </div>
          </div>
        </div>
        <span class='ba-description'>
          {translation(message)}
        </span>
        <div className="ba-content ba-w-100">
          <div className='ba-flex ba-w-100'>
            <button className='ba-btn ba-md ba-light ba-w-50'
              onClick={closeAlert}
            >
              {translation('general-cancel')}
            </button>
            <button className={`ba-btn ba-md ba-mg-l-1 ba-w-50 ${styles[`ba-modal-card__button__${type}`]}`}
              onClick={callback}>
              {translation('general-confirm')}
            </button>
          </div>
        </div>
      </div>

      {/* <div className={styles['wrapper-alert-modal']}>
        <h1>{translation(title)}</h1>

        <div className={styles['wrapper-alert-modal-content']}>
          <p>{translation(message)}</p>
        </div>
        <div className={styles['wrapper-alert-modal-buttons']}>
          <Button
            color="light"
            size="small"
            onClick={closeAlert}
          >
            {translation('general-cancel')}
          </Button>
          <Button
            color="success"
            size="small"
            onClick={callback}
          >
            {translation('general-confirm')}
          </Button>
        </div>
      </div> */}
    </Modal>
  )
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const alerts = getAlerts(state)
  return { translation, alerts }
}


AlertModal.propTypes = {
  isOpened: propTypes.bool,
  title: propTypes.string,
  message: propTypes.string,
  hasCancel: propTypes.bool,
  callback: propTypes.func
}

AlertModal.defaultProps = {
  isOpened: false,
  title: 'Title Modal',
  message: 'Message from Modal',
  hasCancel: true,
  callback: () => { }
}

export default connect(
  mapStateToProps,
  { closeAlert }
)(AlertModal)



// WEBPACK FOOTER //
// ./src/components/AlertModal/index.js